import Select from "components/UI/Select"
import React from "react"
import styled from "styled-components"
import { CURRENCIES } from "./constants"

const Option = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  height: 25px;
  > .flag {
    height: 100%;
    img {
      height: 100%;
      object-fit: contain;
    }
  }
`

const Wrapper = styled.div`
  display: flex;
  // width: 100%;
  width: 320px;
  justify-content: center;
  > :first-child {
    width: 100%;
  }
`

interface IProps {
  currencies: string[]
  currency?: string | null
  onChange: (currency: string) => void
}

export const CurrencySelector = (props: IProps) => {
  return (
    <Wrapper>
      <Select
        theme={{
          selectedColor: "#EC5E2E",
          focusedColor: "rgb(248, 178, 156, 0.5)",
          borderColor: "rgb(248, 178, 156)",
        }}
        onChange={(l: string) => props.onChange(l)}
        value={props.currency || undefined}
        placeholder="Select a currency..."
        options={props.currencies.map(c => {
          const data = CURRENCIES[c]
          if (!data) {
            return { label: c, value: c }
          }
          return {
            label: (
              <Option>
                <div className="flag">
                  <img
                    alt={data.country}
                    src={`https://cdn.nightzookeeper.com/edu-assets/images/flags/${data.country}.png`}
                  />
                </div>
                <div>{data.name}</div>
              </Option>
            ),
            value: c,
          }
        })}
      />
    </Wrapper>
  )
}

export default CurrencySelector
